import React from 'react';
const SortByFilter = ({
  value,
  dropdownList,
  filterData,
  setFilterData,
  setPage,
  fieldName,
}) => {
  const handleChange = (val) => {
    if (setPage) setPage(1);
    if (setFilterData) {
      setFilterData({
        ...filterData,
        page: 1,
        [fieldName]: val,
      });
    }
  };

  return (
    <select
      value={value}
      id={fieldName}
      onChange={(e) => handleChange(e.target.value)}
      className="sm:mr-2 w-full sm:w-auto py-1 h-[42px] mb-2 md:mb-0 border border-gray-200 bg-white"
    >
      {dropdownList.map((item) => (
        <option key={item.value} value={item.value}>
          {item.label || item.name}
        </option>
      ))}
    </select>
  );
};

export default SortByFilter;
